import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
import { fetchStoresListthunkAction } from '../../../redux/Stores/action';
import { selectStores } from 'src/redux/Stores/selector';
import { Icon } from '@iconify/react';
import { FullHeightLoader } from 'src/components/FullHeightLoader';

const NAV_WIDTH = 250;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const getIcon = (name) => <Icon icon={name} width={22} height={22} />;
  const dispatch = useDispatch();
  const [storesArr, setStoresArr] = React.useState([
    {
      id: 1,
      title: 'sales & promotion',
      path: '/',
      icon: getIcon('ion:list'),
      children: [],
    },
  ]);
  const { stores, isLoading } = useSelector(selectStores);
  React.useEffect(() => {
    const fetchStores = async () => {
      dispatch(fetchStoresListthunkAction());
    };
    fetchStores();
  }, []);
  React.useMemo(() => {
    if (stores.length > 0) {
      const arr = [];
      for (let i = 0; i < stores.length; i += 1) {
        arr.push({
          id: stores[i].id,
          title: stores[i].Name,
          path: `/scandata/${stores[i].id}`,
          icon: <Icon icon={'bi:ticket-fill'} width={18} height={16} />,
          children: [],
        });
      }
      setStoresArr([
        {
          id: 1,
          title: 'sales & promotion',
          path: '/',
          icon: getIcon('ion:list'),
          children: [],
        },
        {
          id: 2,
          title: 'scan data',
          path: `/scandata`,
          icon: getIcon('ion:list'),
          children: arr,
        },
      ]);
    }
  }, [stores]);
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column', backgroundColor: '#fff' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex', alignSelf: 'center' }}>
        <Logo />
      </Box>

      {isLoading ? <FullHeightLoader /> : <NavSection data={storesArr} />}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH, bgcolor: '#fff' },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
